import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/pagination/index.js
// module id = 189
// module chunks = 0